import React from "react";
import "./About.css";
import Banner from "../Banner/Banner";

const About = () => {
  const highlights = [
    {
      icon: "🚀",
      title: "Built for Growth",
      desc: "Every page is structured to build trust, drive engagement, and turn visitors into real enquiries.",
    },
    {
      icon: "🎯",
      title: "Design + Strategy",
      desc: "We combine sharp visuals with clear messaging so your site both looks great and performs with purpose.",
    },
    {
      icon: "⚙️",
      title: "Reliable & Scalable",
      desc: "Fast, mobile-ready, and easy to manage — built to grow alongside your business.",
    },
  ];

  const steps = [
    "Understand your goals and audience",
    "Design a clean, focused layout",
    "Build a fast, responsive website",
    "Refine, test, and launch with confidence",
  ];

  return (
    <section className="aboutv6">
      <div className="av6-wrap">
        {/* Top Section */}
        <div className="av6-top">
          <div className="av6-copy">
            <span className="av6-badge">Who We Are</span>
            <h1 className="av6-title">
              We build websites that help
              <span> your business grow</span>
            </h1>
            <p className="av6-sub">
              We create clean, modern websites for businesses who want to make a
              great first impression, build trust online, and attract more
              customers — without the headache.
            </p>

            <div className="av6-actions">
              <a href="/contact" className="av6-btn av6-btn-primary">
                Let's Talk
              </a>
              <a href="/services" className="av6-btn av6-btn-secondary">
                Explore Services
              </a>
            </div>
          </div>

          <div className="av6-feature-card">
            <div className="av6-feature-grid">
              <div className="av6-mini-card">
                <span>Focus</span>
                <strong>Modern & strategic</strong>
              </div>
              <div className="av6-mini-card">
                <span>Approach</span>
                <strong>Clean + purposeful</strong>
              </div>
              <div className="av6-mini-card">
                <span>Priority</span>
                <strong>Speed & clarity</strong>
              </div>
              <div className="av6-mini-card">
                <span>Goal</span>
                <strong>Real business growth</strong>
              </div>
            </div>
          </div>
        </div>

        {/* Story Section */}
        <section className="av6-story">
          <div className="av6-story-card">
            <p className="av6-eyebrow">Our Mission</p>
            <h2>A website should do more than look good — it should grow your business</h2>
            <p>
              We build each site with a clear purpose: attract the right people,
              communicate your value clearly, and encourage them to reach out.
            </p>
          </div>

          <div className="av6-story-card">
            <p className="av6-eyebrow">How We Work</p>
            <ul className="av6-check-list">
              {steps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ul>
          </div>
        </section>

        {/* Highlights */}
        <section className="av6-highlights">
          {highlights.map((item) => (
            <article className="av6-highlight" key={item.title}>
              <div className="av6-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </article>
          ))}
        </section>

        {/* Bottom Section */}
        <section className="av6-bottom">
          <div className="av6-bottom-left">
            <p className="av6-eyebrow">Why Choose Us</p>
            <h2>Quality work, clear process, and results that matter</h2>
            <p>
              We focus on what actually moves the needle — design quality, fast
              performance, and a process that keeps you informed every step of
              the way.
            </p>
          </div>

          <div className="av6-stats">
            <div className="av6-stat">
              <strong>30+</strong>
              <span>projects delivered</span>
            </div>
            <div className="av6-stat">
              <strong>4.9★</strong>
              <span>client satisfaction</span>
            </div>
            <div className="av6-stat">
              <strong>Fast</strong>
              <span>turnaround & support</span>
            </div>
          </div>
        </section>
      </div>

      <Banner />
    </section>
  );
};

export default About;
